import React from 'react';
import Wishlist from '../../components/WishList/index'

const WishlistPage = ({ }) => {
    return (
        <div>
            <Wishlist />
        </div>
    );
}

export default WishlistPage;